import { useId } from 'react';
import { hasDarkBlueHeroTone } from '../utils/heroTone';

type HeroBackgroundProps = {
  imageUrl: string;
  correctBlueTone?: boolean;
};

export function HeroBackground({ imageUrl, correctBlueTone = true }: HeroBackgroundProps) {
  const filterId = `hero-blue-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  const needsCorrection = correctBlueTone && hasDarkBlueHeroTone(imageUrl);

  return (
    <>
      {needsCorrection && (
        <svg className="hero-tone-filter" width="0" height="0" aria-hidden="true" focusable="false">
          <defs>
            <filter id={filterId} colorInterpolationFilters="sRGB">
              {/* Mavi kanaldaki ayrintilari koruyarak koyu kirmizi/yesil kanallari dengeler. */}
              <feColorMatrix
                type="matrix"
                values="0.4 0 0.2 0 0  0 0.8 0.1 0 0  0 0 1 0 0  0 0 0 1 0"
              />
            </filter>
          </defs>
        </svg>
      )}
      <div
        className="bg hero-background"
        style={{
          backgroundImage: `url('${imageUrl}')`,
          filter: needsCorrection ? `url(#${filterId})` : undefined,
        }}
        aria-hidden="true"
      />
    </>
  );
}
